import { useState } from 'react'

import { Divider } from 'antd'
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import FormFooter from '../../antd/Forms/FormFooter'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import FormItem from '../Forms/FormItem'
import SectionsSelector from '../Selectors/SectionsSelector'
import { isFunction } from 'lodash'

export const Modes = Object.freeze({
  SELECTOR: 'selector',
  FORM: 'form'
})

const FIELD_STYLE = { width: '100%' }

const BulkSectionForm = ({ useFooter, onCancel, onChange, onSubmit }) => {
  const t = useSelector(selectTranslate)

  const [sectionIds, setSectionIds] = useState([])
  const [sections, setSections] = useState([])

  const handleSubmit = () => {
    setSections([])
    onSubmit(sections)
  }

  return (
    <div className='flex-column w-100 h-100'>
      <div className='flex-column w-100 pd-12'>
        <FormItem icon={faGraduationCap} label='school_section.form.section_name' required>
          <SectionsSelector
            values={sectionIds}
            style={FIELD_STYLE}
            onChange={(ids, _, entities) => {
              setSectionIds(ids)
              setSections(entities)

              if (isFunction(onChange)) {
                onChange(entities)
              }
            }}
            multiple='multiple'
          />
        </FormItem>
      </div>

      {useFooter && (
        <>
          <Divider className='divider-4' />

          <FormFooter
            cancel={{ text: t('modal.cancel_button') }}
            remove={null}
            submit={{ text: t('modal.ok_button.save'), disabled: sections.length === 0 }}
            onSubmit={handleSubmit}
            onCancel={onCancel}
          />
        </>
      )}
    </div>
  )
}

export default BulkSectionForm
